import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit"
import monitoreReducer from "./features/Monitor/MonitorSlice"
import filterReducer from "./features/Monitor/FilterSlice"
import dataMetaDataReducer from "./features/DataMetadata/DataMetaDataSlice"
import MaintenanceReducer from "./features/Maintenance/MaintenanceSlice"
import ModelMetaDataReducer from "./features/Modeldata/ModelMetaDataSlice"
import DataQualityReducer from "./features/Quality/DataQualitySlice"
import HarmonizationReducer from "./features/Harmonization/HarmonizationSlice"
import MapReducer from "./features/Harmonization/mapping/MapSlice"

export const store = configureStore({
  reducer: {
    monitor: monitoreReducer,
    filters: filterReducer,
    dataMetaData: dataMetaDataReducer,
    maintenance: MaintenanceReducer,
    modelMetaData: ModelMetaDataReducer,
    dataQuality: DataQualityReducer,
    harmonization: HarmonizationReducer,
    map: MapReducer,
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
